(function () {
    class PromoProgress extends HTMLElement {

      constructor() {
        super();
      }
      connectedCallback() {
        this.message = (this.dataset.message) ? this.dataset.message : 0;
        this.addMessage();

      }
      disconnectedCallback() {
        if (this.querySelector('p')) {
            this.querySelector('p').remove();
        }
      }
      addMessage() {
        const node = document.createElement("p");
        node.innerHTML = this.message;
        this.append(node);
      }
    }
    window.customElements.define("promo-progress", PromoProgress);
})();